import React from 'react';
import { connect } from 'react-redux';
import { List } from 'antd';
import { Icon } from 'dlweb-components';
import styled from 'styled-components';

const FileList = ({files, fileProgress, removeFile, isUploading, processing, showLocalFilePicker}) => {

  const onRemoveFile = (e, file) => {
    e.stopPropagation();
    removeFile(file);
  }

  const onListClick = () => {
    if (!processing) {
      showLocalFilePicker();
    }
  }

  return (
    <Container>
      <List
        bordered
        size="small"
        onClick={onListClick}
        style={{background: "#fff", overflow: 'auto', height: '100%', zIndex: 10}}
        dataSource={files}
        renderItem={(file, i) => (
          <List.Item key={i} title={file.name} style={{position: 'relative', height: '42px'}}>
            <div className={`file-icon-small files-small-${file.name.split('.').pop()}`}></div>
            <FileName style={{paddingTop: _.isEmpty(fileProgress) ? '2px' : 0}}>
              {file.name}
              {!_.isEmpty(fileProgress) && fileProgress[file.relativePath]?.totalProgress !== 100 &&
                <div
                  style={{
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#ccc',
                  }}
                >
                  <div style={{
                    backgroundColor: '#5aa7de',
                    height: '100%',
                    width: `${fileProgress[file.relativePath]?.totalProgress || 0}%`,
                  }}>
                  
                  </div>
                </div>
              }

            </FileName>
            {!isUploading && fileProgress[file.relativePath]?.totalProgress !== 100 &&
              <RemoveButton onClick={(e) => onRemoveFile(e, file)}>
                <Icon type='times' style={{marginTop: '4px'}}/>
              </RemoveButton>
            }
            {fileProgress[file.relativePath]?.totalProgress === 100 &&
              <FileButton>
                <Icon type='check-circle' faStyle='fas' style={{marginTop: '4px', color: '#49A422'}}/>
              </FileButton>
            }            


          </List.Item>
        )}
      />
      {files.length === 0 && 
        <Empty onClick={showLocalFilePicker} style={{cursor: 'pointer'}}>
          <Icon type='upload' style={{margin: 'auto', fontSize: '50px', color: '#d9d9d9', alignContent: 'end'}}/>
          <DropDiv>Click or drag here to add files</DropDiv>
        </Empty>
      }
    </Container>
  )
}

const Container = styled.div`
  position: relative;
`

const FileName = styled.div`
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
  flex: auto;
`

const FileButton = styled.div`
  color: #ccc;
  font-size: 12px;
  margin-left: 10px;
`

const RemoveButton = styled(FileButton)`
  cursor: pointer;
  :hover {
    color: #333;
  }
`

const DropDiv = styled.div`
  color: #ccc;
  text-align: center;
  font-size: 16px;
`

const Empty = styled.div`
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  border: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  z-index: 11;
`

const mapStateToProps = state => {
  const { upload } = state;
  return { upload };
};

export default connect(mapStateToProps)(FileList);